import SEO from "@/components/SEO";
import EventsHero from "./components/EventsHero";
import EventsIntroSection from "./components/EventsIntroSection";
import EventsList from "./components/EventsList";
import NewsList from "./components/NewsList";
import EventsCTA from "./components/EventsCTA";

const siteUrl = import.meta.env.VITE_SITE_URL || "";

const eventsSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  name: "活動與最新消息｜TAIAA 台灣 AI 應用推廣協會",
  description:
    "掌握 TAIAA 最新論壇、工作坊、研討會與公益活動資訊。了解 AI 產業趨勢，拓展專業人脈。",
  url: siteUrl ? `${siteUrl}/events` : undefined,
};

export default function Events() {
  return (
    <main className="pt-0">
      <SEO
        title="活動與最新消息｜TAIAA 台灣 AI 應用推廣協會"
        description="掌握 TAIAA 最新論壇、工作坊、研討會與公益活動資訊。了解 AI 產業趨勢，拓展專業人脈。"
        keywords="TAIAA,活動,最新消息,AI 論壇,工作坊,研討會"
        schema={eventsSchema}
      />
      <EventsHero />
      <EventsIntroSection />
      <EventsList />
      <NewsList />
      <EventsCTA />
    </main>
  );
}